@if (!isExpanded) {
    <div
      class="container"
      [style]="{
        border: '2px solid #e1e8fb',
        'border-radius': '10px',
        padding: '5px',
        marginTop: '5px'
      }"
    >
      <div class="row h-4rem align-items-center justify-content-between">
        <div class="col-3 d-flex align-items-center">
          <button
            type="button"
            class="btn btn-primary position-relative program-name"
            (click)="toggleCollapsed()"
            [id]="'toggleCollapseButton-' + annotation?.Label"
          >
            {{ annotation?.Label }} 
          </button>
        </div>
    
        @if (annotation?.DeletedDate) {
        <div class="col-1">
          <p-tag id="deleted-tag" severity="danger" value="Deleted" class="ms-2" />
        </div>
        }
    
        <div class="col-1">
          <i
            class="pi pi-arrow-down pointer"
            style="font-size: 1rem; color: #719eb6"
            (click)="toggleCollapsed()"
          ></i>
        </div>
      </div>
    </div>
    } @else {
    <div
      class="container"
      [style]="{
        border: '2px solid #e1e8fb',
        'border-radius': '10px',
        padding: '5px',
        marginTop: '5px'
      }"
    >
      <div class="row h-4rem align-items-center justify-content-between">
        <div class="col-3 d-flex align-items-center">
          <button
            type="button"
            class="btn btn-primary position-relative program-name"
            (click)="toggleCollapsed()"
            [id]="'toggleCollapseButton-' + annotation?.Label"
          >
            {{ annotation?.Label }}
          </button>
        </div>
    
        @if (annotation?.DeletedDate) {
        <div class="col-1">
          <p-tag id="deleted-tag" severity="danger" value="Deleted" class="ms-2" />
        </div>
        }
    
        <div class="col-1">
          <i
            class="pi pi-arrow-up pointer"
            (click)="toggleCollapsed()"
            style="font-size: 1rem; color: #719eb6"
          ></i>
        </div>
      </div>
    
      <div class="row">
        <div class="col-6">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Annotation Type:</span>
            <span class="text-truncate" style="color: #719eb6">
              {{ graphAnnotationTypeLabel(annotation?.GraphAnnotationType) }}
            </span>
          </div>
        </div>
        <div class="col-6">
          <div
          class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Date Created:</span>
            <span class="text-truncate" style="color: #719eb6">
              {{ annotation?.CreatedDate | date : "MM/dd/yyyy" }}
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        @if (shouldDisplayStartDate()) {
            <div class="col-6">
              <div class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2">
                <span class="fw-bold" style="color: #719eb6">Start Date:</span>
                <span class="text-truncate" style="color: #719eb6">
                  {{ annotation?.StartDate | date : "MM/dd/yyyy hh:mm a" }}
                </span>
              </div>
            </div>
        }

        @if (shouldDisplayEndDate()) {
            <div class="col-6">
              <div class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2">
                <span class="fw-bold" style="color: #719eb6">End Date:</span>
                <span class="text-truncate" style="color: #719eb6">
                  {{ annotation?.EndDate | date : "MM/dd/yyyy hh:mm a" }}
                </span>
              </div>
            </div>
        }

        @if (shouldDisplayYAxisMin()) {
            <div class="col-6">
              <div class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2">
                <span class="fw-bold" style="color: #719eb6">Y Axis Min:</span>
                <span class="text-truncate" style="color: #719eb6">
                  {{ annotation?.YValueStart }}
                </span>
              </div>
            </div>
        }

        @if (shouldDisplayYAxisMax()) {
            <div class="col-6">
              <div
                class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
              >
                <span class="fw-bold" style="color: #719eb6">Y Axis Max:</span>
                <span class="text-truncate" style="color: #719eb6">
                  {{ annotation?.YValueEnd }}
                </span>
              </div>
            </div>
        }
      </div>

      <div class="row">
        <div class="col-6">
          <div
          class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Notes:</span>
            <span class="text-truncate" style="color: #719eb6">
              {{ annotation?.Notes }}
            </span>
          </div>
        </div>
        @if (shouldDisplayBreakSeries()) {
        <div class="col-6">
          <div
          class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Should Break Series:</span>
            <span class="text-truncate" style="color: #719eb6">
              {{ annotation?.ShouldBreakSeries ? 'Yes' : 'No' }}
            </span>
          </div>
        </div>
        }
      </div>

      <div class="row">
        <div class="col-12">
          <div
          class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Associations:</span>
            <span class="text-wrap" style="color: #719eb6; white-space: pre-line;">
              {{ associationsForDisplay() }}
            </span>
          </div>
        </div>
      </div>
    
      <div class="row" id="behaviorActions">
        <div class="col-12">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <button
              (click)="editAnnotation()"
              [id]="'editAnnotationButton-' + annotation?.Label"
              class="side-menu-button2 flex-grow-1 mx-2"
              [disabled]="annotation?.DeletedByUserID || !canManageAnnotations"
              [style.opacity]="annotation?.DeletedByUserID || !canManageAnnotations ? '0.5' : '1'"
              [style.cursor]="annotation?.DeletedByUserID || !canManageAnnotations ? 'not-allowed' : 'pointer'"
            >
              Edit Annotation
            </button>
    
            <button
              (click)="deleteAnnotation()"
              [id]="'deleteAnnotationButton-' + annotation?.Label"
              class="switch-mode-button flex-grow-1 mx-2"
              [disabled]="annotation?.DeletedByUserID || !canManageAnnotations"
              [style.opacity]="annotation?.DeletedByUserID || !canManageAnnotations ? '0.5' : '1'"
              [style.cursor]="annotation?.DeletedByUserID || !canManageAnnotations ? 'not-allowed' : 'pointer'"
            >
              Delete Annotation
            </button>
          </div>
        </div>
      </div>
    </div>
    }
    